import React from "react";
import Footer from "../../components/Footer";
import Individualfreezone from "../../components/Individualfreezone";

const individualfreezone = () => {
  return (
    <>
      {/* Main Section  */}
      <section>
        <Individualfreezone />
      </section>

      {/* Footer Section  */}
      <section>
        <Footer />
      </section>
    </>
  );
};

export default individualfreezone;